var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArticleSearchLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.625 8.33334H17.7083M15.625 12.5H17.7083M12.5 16.6667H7.29167M21.875 12.5V6.25001C21.875 5.69747 21.6555 5.16757 21.2648 4.77687C20.8741 4.38617 20.3442 4.16667 19.7917 4.16667H5.20833C4.6558 4.16667 4.12589 4.38617 3.73519 4.77687C3.34449 5.16757 3.125 5.69747 3.125 6.25001V18.75C3.125 19.3025 3.34449 19.8324 3.73519 20.2231C4.12589 20.6138 4.6558 20.8333 5.20833 20.8333H12.5M7.29167 8.33334V12.5H11.4583V8.33334H7.29167Z",
    stroke: "#52447D",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0709 20.0708C20.3128 19.829 20.5046 19.5419 20.6355 19.2259C20.7664 18.9099 20.8338 18.5712 20.8338 18.2292C20.8338 17.8871 20.7664 17.5485 20.6355 17.2325C20.5046 16.9165 20.3128 16.6293 20.0709 16.3875C19.8291 16.1456 19.542 15.9538 19.226 15.8229C18.91 15.692 18.5713 15.6246 18.2293 15.6246C17.8872 15.6246 17.5486 15.692 17.2326 15.8229C16.9166 15.9538 16.6295 16.1456 16.3876 16.3875C15.8992 16.8759 15.6248 17.5384 15.6248 18.2292C15.6248 18.9199 15.8992 19.5824 16.3876 20.0708C16.876 20.5593 17.5385 20.8337 18.2293 20.8337C18.92 20.8337 19.5825 20.5593 20.0709 20.0708ZM20.0709 20.0708L21.8751 21.875",
    stroke: "#52447D",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArticleSearchLine);
export default __webpack_public_path__ + "static/media/article-search-line.815dd8c63dd836fd6341851dc014406a.svg";
export { ForwardRef as ReactComponent };